import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

import home_store from './home_store';
import app_store from './app_store';

export default new vuex.Store({
    modules: {
        home:home_store,
        app:app_store,
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js